import { commonApi } from '@common/utils/baseQuery';
import appReducer from '@features/app/slice/appSlice';
import authReducer from '@features/auth/slice/authSlice';
import personalPopupReducer from '@features/banners/slice/personalPopupSlice';
import basketReducer from '@features/basket/slice/basketSlice';
import bonusExpressReducer from '@features/bonus-express/slice/bonusExpressSlice';
import campaignsReducer from '@features/campaigns/slice/campaignsSlice';
import { preMatchApi } from '@features/event/api/eventApi';
import eventReducer from '@features/event/api/eventSlice';
import forecastReducer from '@features/forecast-euro/slice/forecastSlice';
import admiralCampaignsReducer from '@features/freespin/slice/admiralCampaignsSlice';
import { engagementSlice } from '@features/engagement/slice/engagementSlice';
import liveReducer from '@features/live/slice/liveSlice';
import messagesReducer from '@features/messages/slice/messagesSlice';
import admiralUserBonusesReducer from '@features/my-bonuses/slice/admiralUserBonusesSlice';
import userBonusCardsReducer from '@features/my-bonuses/slice/userBonusCardsSlice';
import oddsReducer from '@features/odds-templates/slice/oddsTemplatesSlice';
import popularOutcomesReducer from '@features/popular-outcomes/popularOutcomesSlice';
import translationsReducer from '@features/translations/slice/translationsSlice';
import verificationReducer from '@features/verification/slice/verificationSlice';
import { worldCupForecastSlice } from '@features/world-cup-forecast/model/slice';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    app: appReducer,
    auth: authReducer,
    basket: basketReducer,
    campaigns: campaignsReducer,
    forecast: forecastReducer,
    admiralCampaigns: admiralCampaignsReducer,
    admiralUserBonuses: admiralUserBonusesReducer,
    engagement: engagementSlice.reducer,
    userBonusCards: userBonusCardsReducer,
    live: liveReducer,
    messages: messagesReducer,
    oddsSchema: oddsReducer,
    personalPopup: personalPopupReducer,
    popularOutcomes: popularOutcomesReducer,
    translations: translationsReducer,
    verification: verificationReducer,
    bonusExpress: bonusExpressReducer,
    event: eventReducer,
    [preMatchApi.reducerPath]: preMatchApi.reducer,
    [commonApi.reducerPath]: commonApi.reducer,
    worldCupForecast: worldCupForecastSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }).concat([
      commonApi.middleware,
    ]),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
// export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
